export default {
      id: "icon-chaussure-converse-usage",
      viewBox: "0 0 137.2 80.6",
      url: __webpack_public_path__ + "icons.svg#icon-chaussure-converse",
      toString: function () {
        return this.url;
      }
    }